import styles from './BgVideo.module.css';

import bgVideo from '../../assets/video/bgVideo.webm';
import bgPoster from '../../assets/images/bgPoster.webp';
import { memo } from 'react';

export const BgVideo = memo(() => {
  return (
    <div className={styles.bgVideoWrapper}>
      <video
        playsInline
        autoPlay="autoplay"
        muted="muted"
        loop
        id="bgVideo"
        poster={bgPoster}
      >
        <source src={bgVideo} type="video/webm" />
      </video>
    </div>
  );
});
